export default __webpack_public_path__ + "56c938764e05862be6491b197601a4bc.svg";